import { render, staticRenderFns } from "./zAlerta.vue?vue&type=template&id=48598450&scoped=true&"
import script from "./zAlerta.vue?vue&type=script&lang=js&"
export * from "./zAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48598450",
  null
  
)

export default component.exports